import { axiosPost } from '../axios/axios.config';

export const allMobileNotification = async (data) => {
  const response = await axiosPost('data/api/mobilenotifications', data);
  return response;
};

export const singleMobileNotification = async (uuid, data) => {
  const response = await axiosPost(`data/api/mobilenotification/${uuid}`, data);
  return response;
};
